import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import useQueryString from '../../../hooks/use-query-string'
import { Background, Option, SeniorImage } from '../../../models'
import SeniorPackageInstructions from '../../senior-package-instructions'
import SeniorPortraitOptionItem from '../../senior-portrait-option-item'
import classes from './senior-option-selection.module.sass'
import packageBuilderHelperClasses from '../../package-builder-helper/package-builder-helper.module.sass'

const SeniorOptionSelection = () => {
  const { packageId } = useParams()
  const { favs: favorites, bg: backgroundId } = useQueryString()

  useEffect(() => {
    document.body.classList.remove(packageBuilderHelperClasses.overflowHidden)
  }, [])

  const [studentImages, setStudentImages] = useState(null)
  const [packageOptions, setPackageOptions] = useState(null)
  const [background, setBackground] = useState(null)

  useEffect(() => {
    Option
      .includes(['image_types', 'prices'])
      .where({ packageId })
      .order('name')
      .all()
      .then((res) => setPackageOptions(res.data))
  }, [packageId])

  useEffect(() => {
    Background
      .find(backgroundId)
      .then((res) => setBackground(res.data))
  }, [backgroundId])

  useEffect(() => {
    SeniorImage
      .where({ id: favorites })
      .all()
      .then((res) => setStudentImages(res.data))
  }, [JSON.stringify(favorites)])

  if (!(studentImages && packageOptions && background)) return null

  return (
    <div className={classes.container}>
      <SeniorPackageInstructions
        title="Please select your package."
      />
      <div>
        {packageOptions.map((packageOption) => (
          <SeniorPortraitOptionItem
            key={packageOption.id}
            favorites={studentImages}
            background={background}
            packageOption={packageOption}
          />
        ))}
      </div>
    </div>
  )
}

export default SeniorOptionSelection
